import { Users, LayoutDashboard, Bot, BarChart2 } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const CARD_KEYS = [
  { icon: Users, key: "agency.benefits.c1", featured: true },
  { icon: LayoutDashboard, key: "agency.benefits.c2", featured: false },
  { icon: Bot, key: "agency.benefits.c3", featured: false },
  { icon: BarChart2, key: "agency.benefits.c4", featured: false },
];

export function AgencyBenefits() {
  const { t } = useI18n();
  return (
    <section className="py-24 px-6" style={{ backgroundColor: "#0a1845" }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-4 text-white">
            {t("agency.benefits.title")}
          </h2>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: "#94a3b8" }}>
            {t("agency.benefits.desc")}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {CARD_KEYS.map(({ icon: Icon, key, featured }) => (
            <div
              key={key}
              className={`relative p-7 rounded-3xl ${featured ? "lg:col-span-2 lg:row-span-1" : ""}`}
              style={{ backgroundColor: "#0e2058", border: "1px solid #163554" }}
            >
              <div className="relative inline-flex mb-5">
                <span aria-hidden className="absolute inset-0 rounded-2xl blur-xl" style={{ backgroundColor: "rgba(232,114,26,0.45)" }} />
                <div className="relative w-12 h-12 rounded-2xl flex items-center justify-center" style={{ backgroundColor: "rgba(232,114,26,0.12)" }}>
                  <Icon className="w-6 h-6" style={{ color: "#e8721a" }} />
                </div>
              </div>
              <h3 className={`font-bold mb-2 text-white ${featured ? "text-2xl" : "text-lg"}`}>{t(`${key}.title`)}</h3>
              <p className={`leading-relaxed ${featured ? "text-base" : "text-sm"}`} style={{ color: "#94a3b8" }}>{t(`${key}.desc`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
